import { animate, state, style, transition, trigger } from '@angular/animations';
import { CdkPortalOutlet, ComponentPortal } from '@angular/cdk/portal';
import { AfterContentInit, AfterViewInit, Component, ContentChildren, EventEmitter, Input, OnInit, Optional, Output, QueryList, TemplateRef, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import * as _ from 'lodash';
import { MessageService, PrimeTemplate, TreeNode } from 'primeng/api';
import { Tree } from 'primeng/tree';
import { Subscription } from 'rxjs';
import { DetailComponent } from '../../models/detail-component';
import { TreeNodeEvent } from '../../models/tree-node-event';
import { DetailCompResolverService } from '../../services/detail-comp-resolver.service';
import { ExplorerDataService } from '../../services/explorer-data.service';


/*
  Explorer type component
  Left side is a tree or list or customize components
  Right side is dynamic based on render data (grid/pdf viewer/others)
  Left side and right side can share a same data instance, but right side component may call api inside
  Ad-explorer has a default layout with default parser service

  To customize the component, user can wrap out side (ng-template)

  !tree has issue on virtual scroll, be careful

  Usage: document/email


  injections:
    service
      method parseData

  inputs:
    data: IExplorerData
      most time it's a tree type, but we don't restrict to it. because the left side can be customized (implement interface)
      don' limit data structure here, the service will response to parse data to component capble structure
    navigate component (optional)

  fields:
    naviData

  method
    view(data)
*/
@Component({
  selector: 'ad-explorer',
  templateUrl: './ad-explorer.component.html',
  styleUrls: ['./ad-explorer.component.scss'],
  // Cannot inject detailcompresolver here, please pass in
  providers: [MessageService],
  // animations: [trigger('slideIn', [
  //   state('hidden', style({ width: 0, 'box-shadow': 'none' })),
  //   state('visible', style({ 'max-height': 400 })),
  //   transition('hidden => visible', animate('150ms ease-in')),
  //   transition('visible => hidden', animate('150ms ease-out'))
  // ])]
})
export class AdExplorerComponent implements OnInit, AfterViewInit, AfterContentInit {
  _data: any;
  @Input()
  get data() {
    return this._data;
  }
  set data(val) {
    this._data = val;
    if (this.dataService) {
      this.dataService.parse(this._data);
    }
  }
  // parsed naviData, passed in or parse from data
  @Input()
  naviData;
  // parsed detailData, passed in or parse from data
  @Input()
  detailData;

  @Input()
  showToggle = false;

  @Input()
  styleClass = '';

  @Input()
  selectionMode = 'single';

  // when select node by checkbox ,select inside node or not
  // true may have performance when node data is large
  @Input()
  propagateSelectionDown = false;

  @Input()
  menuFunc: (node: TreeNode | TreeNode[], tree) => any[];

  // placeholer to render detail component
  @ViewChild(CdkPortalOutlet, { static: false })
  cdkPortalOutlet: CdkPortalOutlet;

  // depend on primeng template to parse template
  // tree node templates
  @ContentChildren(PrimeTemplate)
  templates: QueryList<any>;

  // only tree structure support path (bread crumb menu)
  path: TreeNode[];

  private _selectedNode: TreeNode | TreeNode[];
  @Input()
  get selectedNode() {
    return this._selectedNode;
  }
  set selectedNode(val) {
    this._selectedNode = val;
    let node: TreeNode | TreeNode[] = val;
    if (node) {
      if (this.tree) {
        if (!_.isArray(node)) {
          this.buildParent(node as TreeNode, this.tree.value);
        }
        else {
          this.buildParents(node as TreeNode[], this.tree.value);
        }
        if (this.menuFunc) {
          this.menuItems = this.menuFunc(node, this.tree);
        }
      }
      if (!_.isArray(node)) {
        // when node changed, render detail of the node
        this.renderDetail(node as TreeNode);
        this.calcPath(node as TreeNode);
      }
    }

  }

  naviTemplate: TemplateRef<any>;

  templateMap: { [key: string]: TemplateRef<any> } = {};




  @Input()
  treeData: TreeNode[];

  @Input()
  sideNaviMode = 'side';

  @Input()
  sideNaviOpened = true;

  @Input()
  hasBackdrop = false;

  @Input()
  hasBreadCrumb = true;

  detailComponent: DetailComponent;

  @ViewChild(Tree)
  tree: Tree;

  @Output()
  onNodeSelected = new EventEmitter<TreeNode>();

  @Input()
  pathTemplate: any;

  @ViewChild('drawer')
  drawer: MatDrawer;

  @Input()
  hasHeaderInMain = true;

  constructor(
    @Optional() private dataService: ExplorerDataService,
    @Optional() private detailCompResolver: DetailCompResolverService
  ) {
    console.log(detailCompResolver);
  }
  ngAfterViewInit(): void {
    if (this.selectedNode) {
      let node: TreeNode | TreeNode[] = this.selectedNode;
      if (this.tree) {
        if (!_.isArray(node)) {
          this.buildParent(node as TreeNode, this.tree.value);
        }
        else {
          this.buildParents(node as TreeNode[], this.tree.value);
        }
        if (this.menuFunc) {
          this.menuItems = this.menuFunc(node, this.tree);
        }
      }
      if (!_.isArray(node)) {
        // when node changed, render detail of the node
        this.renderDetail(node as TreeNode);
        this.calcPath(node as TreeNode);
      }
    }
  }

  toggleSideNav() {
    this.drawer.toggle();
  }

  buttonsTemp: TemplateRef<any>;

  ngOnInit(): void {
    this.menuItems = [
      // { label: 'View', icon: 'fa fa-search', command: () => this.viewFile(this.selectedNode) },
      // { label: 'Unselect', icon: 'fa fa-times', command: () => this.unselectFile() },
      // { label: 'Delete', icon: 'fa fa-trash', command: () => this.delete(this.selectedNode) }
    ];
  }
  ngAfterContentInit() {


    // if (this.templates.length) {
    //   this.templateMap = {};
    // }

    this.templates.forEach((item) => {
      this.templateMap[item.name] = item.template;
    });
    console.log(this.templateMap);
  }

  delete(node: TreeNode) {
    node.parent.children.splice(node.parent.children.indexOf(node), 1);
  }

  private nodeSelectedSub: Subscription;

  renderDetail(node: TreeNode) {
    if (!this.cdkPortalOutlet) {
      console.log('use main template to render detail');
      this.onNodeSelected.emit(node);
      return;
    }
    // CDK Portal mode
    // CDK Protal is more powerfull, support (DOM and Template as well)
    console.log('clear components at first');
    if (this.cdkPortalOutlet.hasAttached()) {
      // this.cdkPortalOutlet.portal.detach();
      this.cdkPortalOutlet.detach();
    }

    if (this.detailCompResolver && node) {
      const detailComponent = this.detailCompResolver.resolve(node);
      if (detailComponent) {
        console.log('render components');
        // Resolve portal beased on data
        const portal = new ComponentPortal<DetailComponent>(detailComponent.componentType);
        // Attach to portal outlet
        const compRef = this.cdkPortalOutlet.attach(portal);
        compRef.instance.node = node;
        if (detailComponent.inputs) {
          Object.assign(compRef.instance, detailComponent.inputs);
        }
        this.subscribeEvents(compRef.instance);
        this.detailComponent = compRef.instance;
        // These will be called before ngOnInit of component
        // self initialize data for comp
        // compRef.instance.formGroup = new FormGroup({
        //   name: new FormControl('123')
        // });
        // compRef.instance.option = <FieldOption>{
        //   name: 'name',
        //   required: true,
        //   inputType: InputType.TextBox
        // }
        // portal component ngOnInit will be called
      }
    }

  }



  nodeSelect(event) {
    // no as expect
    // let parent = event.node as TreeNode;
    // while (parent) {
    //   if (!parent.expanded) {
    //     parent.expanded = true;
    //   }
    //   parent = parent.parent;
    // }
  }

  // componentAttached(event: CdkPortalOutletAttachedRef) {
  //   this.buttonsTemp = this.detailComponent.buttons;
  // }

  private calcPath(selectedNode: TreeNode = null) {
    if (!selectedNode) {
      this.path = [];
      return;
    }
    // keep original node reference in data
    const path = [{ ...selectedNode, icon: selectedNode.collapsedIcon || selectedNode.icon, data: selectedNode }];
    while (selectedNode.parent) {
      path.push({ ...selectedNode.parent, icon: selectedNode.parent.collapsedIcon || selectedNode.parent.icon, data: selectedNode.parent });
      selectedNode = selectedNode.parent;
    }
    this.path = path.reverse();
  }
  private nodeEventSub: Subscription;
  private subscribeEvents(compRef: DetailComponent) {
    if (this.nodeEventSub) this.nodeEventSub.unsubscribe();
    if (compRef.onRequestNodeUpdate) {
      this.nodeEventSub = compRef.onRequestNodeUpdate.subscribe(nodeEvent => {
        this.handleEvents(nodeEvent);
      })
    }
  }
  private handleEvents(event: TreeNodeEvent) {
    switch (event.type) {
      case 'add':
        this.addNode(event.node);
        break;
      case 'collapse':
        this.collapseNode(event.node);
        break;
      case 'delete':
        this.deleteNode(event.node);
        break;
      case 'expand':
        this.expandNode(event.node);
        break;
      case 'select':
        this.selectNode(event.node);
        break;
      case 'toggle':
        this.toggleNode(event.node)
        break;
      case 'update':
        this.updateNode(event.node);
        break;
    }
  }
  addNode(node: TreeNode) {
    node.parent.children.push(node);
    node.parent.children = _.sortBy(node.parent.children, 'label');
    this.tree.updateSerializedValue();
  }
  collapseNode(node) {

  }
  deleteNode(node: TreeNode) {
    let children = [];
    if (!node.parent) {
      // one of the root Node
      children = this.treeData;
    }
    else {
      children = node.parent.children;
    }
    const index = children.findIndex(n => n.key == node.key);
    if (index >= 0) {
      children.splice(index, 1);
      this.tree.updateSerializedValue();
    }
  }
  expandNode(node: TreeNode) {
    node.expanded = true;
    this.tree.updateSerializedValue();
  }
  selectNode(node: TreeNode) {
    // select node by breadcrumb menu
    this.selectedNode = node.data;
  }
  toggleNode(node: TreeNode) {
    node.expanded = !node.expanded;
    this.tree.updateSerializedValue();
  }
  updateNode(node: TreeNode) {

  }

  viewFile(file: TreeNode) {
    console.log(file);
    // this.messageService.add({ severity: 'info', summary: 'Node Details', detail: file.label });
  }

  unselectNode() {
    this.selectedNode = null;
  }

  // selectedFile: any = null;

  menuItems = [];

  resetUI() {
    this.sideNaviOpened = true;
  }

  private buildParents = (nodes: TreeNode[], treeNodes: TreeNode[], path: TreeNode[] = []) => {
    nodes.forEach(node => this.buildParent(node, treeNodes, []));
  }

  private buildParent = (node: TreeNode, treeNodes: TreeNode[], path: TreeNode[] = []) => {
    for (let i = 0; i < treeNodes.length; i++) {
      if (treeNodes[i] == node) {
        path.push(node);
        // build parent links
        path.reduce((pre, cur) => { cur.parent = pre; return cur; }, null);
        return true;
      }
      else if (treeNodes[i].children && treeNodes[i].children.length > 0) {
        path.push(treeNodes[i]);
        if (this.buildParent(node, treeNodes[i].children, path)) {
          return true;
        }
        else {
          path.pop();
        }
      }
    }
    return false;
  }
}
